export enum EEmplacementMesure {
    BergePonton = 1,
    Embarcation = 2,
}